<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header">
        <div @click="$router.go(-1)" class="goBack c-position-static c-m-0">
          <i class="el-icon-arrow-left"></i>
          <span>{{ typeName }}单</span>
          <i class="el-icon-box"></i>
        </div>
        <div v-if="formData.state == 0" class="c-m-r-10 c_gray">已作废</div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          :area="area"
          labelWidth="95px"
          @changeForm="osg.changeForm"
        >
          <template slot="handleType">
            <el-select v-model="formData.handleType" clearable>
              <el-option
                v-for="item in options['handleType' + this.type]"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
              ></el-option>
            </el-select>
          </template>
          <template slot="warehouseId">
            <el-select
              v-model="formData.warehouseId"
              placeholder="可以通过输入仓库名称查询"
              clearable
              filterable
            >
              <el-option
                v-for="item in options.warehouses"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span class="c-fl">{{ item.label }}</span>
                <span class="c-fr c-font-13">{{ item.code }}</span>
              </el-option>
            </el-select>
          </template>
        </c-form>
      </div>
      <div class="box-left-footer">
        <!-- <el-button type="primary" @click="doSave">提交</el-button> -->
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="产品" name="productList">
          <div class="box-center-content">
            <el-table ref="productList" :data="formData.productList" highlight-current-row>
              <el-table-column
                label="产品名称"
                width="200px"
                prop="name"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="产品编号"
                width="100px"
                prop="code"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="规格型号"
                width="100px"
                prop="model"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="单位"
                width="120px"
                prop="unit"
                :formatter="formatProductUnit"
              ></el-table-column>
              <el-table-column
                :label="this.typeName + '数量'"
                prop="count"
                width="150px"
              ></el-table-column>
              <el-table-column label="序列号" width="300px">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(code, i) in scope.row.pIICodes || []"
                    :key="i"
                    style="margin:0 5px 5px 0"
                  >
                    {{ code }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="memo"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse v-model="activeCollapse"></el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'inventoryItem',
  data() {
    window.$this = this;
    return {
      id: null,
      type: '',
      typeName: '',
      collapse: true,
      activeCollapse: '1',
      formData: {
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_productUnit: {
          codeId: 'partUnit'
        },
        codecfg_type: { codeId: 'inventoryItemType' }
      },
      rules: this.$util.rules,
      activeTab: 'productList',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      }
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    this.osg.getFields('inventoryItem', () => {
      this.getWarehouses();
      this.getData();
    });
    this.getLog();
    this.getNote();
  },
  methods: {
    formatProductUnit(row, column, cellValue) {
      return this.osg.codelabel('productUnit', cellValue);
    },
    formatProductType(row, column, cellValue) {
      return this.osg.codelabel('productType', cellValue);
    },
    getData() {
      this.osg.ajax('basic/inventoryItem/findById.do', { id: this.id }, res => {
        this.type = res.data.type;
        this.typeName = this.osg.codelabel('type', this.type) || '出入库明细';
        let row = res.data;
        row.exts = row.exts || {};
        this.$util.renderExtField(this.extFields, row);
        this.formData = row;
        //获取属性修改记录
        this.getHistory();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        let row = this.$util.deepCopy(this.formData);
        let params = row;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }
        this.$util.saveExtField(this.extFields, row);
        this.osg.ajax('basic/inventoryItem/upsert.do', { json: JSON.stringify(row) }, () => {
          this.osg.toast('保存成功！');
          this.getData();
        });
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'inventoryItem',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    getFields() {
      this.osg.ajax(
        'biz/ext/queryByColName/inventoryItem.do',
        {},
        res => {
          res.entity.extFieldList.map(item => {
            item.label = item.nameDisp;
            item.value = item.name;
          });
          this.options.fields = res.entity.extFieldList;
        },
        {
          noload: true
        }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'inventoryItem'
        },
        res => {
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'inventoryItem',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    getWarehouses() {
      this.osg.ajax('basic/wareHouse/query.do', { _all: '1', 'is:state|integer#and': 1 }, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.warehouses = res.data;
        this.$forceUpdate();
      });
    }
  }
};
</script>
